import "./AddDealAppointments.css";
import React, { useState } from "react";
import NoDataFound from "../NoDataFound/NoDataFound";
import ConfirmationModal from "../../../components/Common/ConfirmationModal/ConfirmationModal";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../../../firebase";
import AppointmentListingCard from "../../../components/Common/AppointmentListingCard/AppointmentListingCard";
import AddUpdateAppointmentModal from "../../../components/Common/AddUpdateAppointmentModal/AddUpdateAppointmentModal";

const AddDealAppointments = ({
  appointments,
  setAppointments,
  selectedAppointmentClient,
  isUpdate,
  isBtnDisable,
  dealId,
  ErrorHandling,
  dealData,
  Toggler,
  ToggleComponents,
}) => {
  const [singleVisit, setSingleVisit] = useState(null);
  const [modalStatus, setModalStatus] = useState("");
  const [toggleAppointments, setToggleAppointments] = useState(false);
  const [DeleteDialog, setDeleteDialog] = useState(false);
  const handleOpenDeleteDialog = () => {
    setDeleteDialog(true);
  };

  const [Refresh, setRefresh] = useState(true);
  const [AppointmentId, setAppointmentId] = useState("");
  const [OpenAddUpdateModal, setOpenAddUpdateModal] = useState(false);

  const handleRefresh = () => {
    setRefresh(!Refresh);
  };

  console.log("appointmentsappointments", appointments);
  return (
    <>
      <div
        className={`deal-appointment-card ${
          isBtnDisable === true && "custom-disable-card"
        }`}
      >
        <div className="deal-appointment-card-content">
          <div
            className="deal-appointment-card-header"
            // onClick={() => {
            //   const flag = ErrorHandling();
            //   if (flag === 0) {
            //     setAppointmentId("");
            //     setOpenAddUpdateModal(true);
            //   }
            // }}
          >
            <p className="deal-appointment-card-title">Add Appointments</p>
            <svg
              width="13"
              height="14"
              viewBox="0 0 13 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.27236 3.9197H11.203M4.41497 1.06285V3.8397M8.0604 1.06285V3.58259M11.4754 4.99958V8.4278C11.4754 8.5535 11.4754 8.6792 11.4649 8.79919C11.245 8.50346 10.9671 8.26527 10.6516 8.10212C10.3362 7.93897 9.99127 7.85502 9.64218 7.85643C9.08699 7.85643 8.5737 8.06784 8.17039 8.42208C7.89304 8.6612 7.6692 8.96604 7.51584 9.3135C7.36248 9.66097 7.28362 10.042 7.28522 10.4276C7.28605 10.8086 7.36448 11.1846 7.51485 11.5285C7.66522 11.8724 7.88376 12.1755 8.15468 12.416C8.04469 12.4274 7.92946 12.4274 7.80899 12.4274H4.66638C2.04754 12.4274 1 11.2846 1 8.4278V4.99958C1 2.14274 2.04754 1 4.66638 1H7.80899C10.4278 1 11.4754 2.14274 11.4754 4.99958Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12.0001 10.4291C11.9993 10.7951 11.927 11.1567 11.7879 11.4897C11.6488 11.8227 11.4461 12.1196 11.1934 12.3603C10.7797 12.7603 10.2402 13.0002 9.64309 13.0002C9.08266 13.0002 8.56413 12.7831 8.16083 12.4174H8.15559C7.88467 12.177 7.66613 11.8739 7.51576 11.53C7.36539 11.1861 7.28696 10.8101 7.28613 10.4291C7.28613 9.61773 7.62658 8.89209 8.1713 8.42357C8.58817 8.05696 9.10763 7.85732 9.64309 7.85791C10.3816 7.85791 11.0363 8.22359 11.4658 8.80067C11.801 9.24062 12.0001 9.81199 12.0001 10.4291Z"
                stroke="white"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.72559 10.4272L9.30697 11.0614L10.564 9.79297"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <div className="deal-appointment-card-body">
            <div className="title-container">
              <div className="left">
                <span className="appointment-file-title">Appointments </span>
                <span className="tot-files">
                  ({appointments.length} Appointments )
                </span>
              </div>
              <div className="right">
                <div
                  onClick={() => {
                    if (isBtnDisable === false) {
                      // setToggleAppointments(!toggleAppointments);
                      Toggler();
                    }
                  }}
                  className={`transaction-toggler  ${
                    !ToggleComponents ? "toggle-active" : " "
                  }  `}
                >
                  <svg
                    width="17"
                    height="9"
                    viewBox="0 0 17 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.8"
                      d="M16.2271 8.0975L9.87105 1.5775C9.12041 0.8075 7.89209 0.8075 7.14145 1.5775L0.7854 8.0975"
                      stroke="#545454"
                      strokeWidth="1.5"
                      strokeMiterlimit={10}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
              </div>
            </div>
            {ToggleComponents && appointments.length > 0 ? (
              <div className="deal-appointment-elements-container">
                {appointments.map((appointment, index) => {
                  return (
                    <AppointmentListingCard
                      // onClick={() => {
                      //   setAppointmentId(appointment.id);
                      //   setOpenAddUpdateModal(true);
                      // }}
                      appointment={appointment}
                    />
                  );
                })}
              </div>
            ) : (
              ToggleComponents && (
                <div
                  className="add-deal-common-btn"
                  // onClick={() => {
                  //   const flag = ErrorHandling();
                  //   if (flag === 0) {
                  //     setAppointmentId("");
                  //     setOpenAddUpdateModal(true);
                  //   }
                  // }}
                >
                  <svg
                    width={28}
                    height={27}
                    viewBox="0 0 28 27"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M26.6097 13.2033H1M13.8048 1V26.0067"
                      stroke="#767676"
                      strokeMiterlimit={10}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <h3>Add Appointments</h3>
                </div>
              )
            )}
          </div>
        </div>
      </div>
      <AddUpdateAppointmentModal
        AppointmentId={AppointmentId}
        setAppointmentId={setAppointmentId}
        handleRefresh={handleRefresh}
        OpenAddUpdateModal={OpenAddUpdateModal}
        setOpenAddUpdateModal={setOpenAddUpdateModal}
        selectedAppointmentClient={selectedAppointmentClient}
        dealId={dealId}
        dealData={dealData}
      />
    </>
  );
};

export default AddDealAppointments;
